import { entityAPI, logAPI } from "api/GenericAPI";
import { Conversation , ConversationLog } from "api/Interactions/InteractionsInterfaces";

export const conversationsAPI = entityAPI<Conversation>("interactions", "conversations");
export const conversationLogAPI = logAPI<ConversationLog>("interactions", "conversations");

